export default __webpack_public_path__ + "static/media/30.8075b027.png";